// extracted by mini-css-extract-plugin
module.exports = {"carousel-track":"Carousel_carousel-track__vlBkT","carouselArrowLeft":"Carousel_carouselArrowLeft__ThO4S","carouselArrowRight":"Carousel_carouselArrowRight__wjv2g"};